import NotificationsModalMailInfoView from "./NotificationsModalMailInfo.html";
import ChangeEmailsModalView from "./changeEmailsModal.html";
import _ from 'lodash';



angular.module("notifications")

    .controller("NotificationsEditCtrl", ['$uibModal', '$rootScope', '$scope', '$http', '$stateParams', 'Restangular', '$state', 'modalService', '$filter', 'gridService', 'logService',
        function ($uibModal, $rootScope, $scope, $http, $stateParams, Restangular, $state, modalService, $filter, gridService, logService) {
        
        $rootScope.title = $filter('translate')('notifications.title');
        logService.debug($stateParams.notificationId);
        $scope.showData = 'showInfo';

        $scope.sent = 0;
        $scope.sending = 0;
        $scope.error = 0;
        $scope.eventId = null;
        $scope.search = {
            email: null,
            fullname: null
        }


        if (typeof ($stateParams.id) !== 'undefined') {
            $scope.eventId = $stateParams.id;
        }

        if (angular.isUndefined($stateParams.notificationId) || $stateParams.notificationId == "") {
            
            $rootScope.breadcrumb = [
                { title: $filter('translate')('notifications.list'), url: "notifications.list" },
                { title: $filter('translate')('notifications.button_view') }
            ];
            $scope.company = {
                name: '',
                created_at: new Date()
            };
        }
        else {

            var loadSent = function () {
                if (angular.isDefined($scope.gridSent)) {
                    $scope.gridSent.loadData(false);
                } else {
                    $scope.gridSent = {
                        pdfTitle: $filter('translate')('notifications.pdf_sent'),
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        gridMenuShowHideColumns: false,
                        paginationPageSizes: [40, 100, 150],
                        paginationPageSize: 40,
                        rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        columnDefs: [
                            { name: 'id', visible: true, enableHiding: false, exporterSuppressExport: true, maxWidth: 80 },
                            {
                                name: 'real_send_date', displayName: $filter('translate')('notifications.date'), maxWidth: 125, minWidth: 80,
                                type: 'real_send_date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                                customFormatFn: function (value) {
                                    if (value != null) {
                                        var fecha = new Date(value);
                                        return $filter('date')(fecha, 'dd/MM/yyyy');
                                    }
                                    return "";
                                },
                                enableFiltering: false, enableColumnMenu: false
                            },
                            { name: 'person_name', displayName: $filter('translate')('persons.name'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            { name: 'mails', displayName: $filter('translate')('companies.email'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            { name: 'times_opened', displayName: $filter('translate')('notifications.times_opened'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            {
                                name: 'last_time_opened', displayName: $filter('translate')('notifications.last_time_opened'), maxWidth: 125, minWidth: 80,
                                type: 'last_time_opened', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                                customFormatFn: function (value) {
                                    if (value != null) {
                                        var fecha = new Date(value);
                                        return $filter('date')(fecha, 'dd/MM/yyyy');
                                    }
                                    return "";
                                },
                                enableFiltering: false, enableColumnMenu: false
                            },
                            {
                                name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                    { title: $filter('translate')('notifications.button_view'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit" },
                                ], { cssClass: "pull-right" })
                            },
                        ],
                        getData: function (options) {
                            //var deferred = $q.defer();
                            options.notification_email_id = $stateParams.notificationId;
                            options.state = "sent";
                            options.name = $scope.search.fullname;
                            options.email = $scope.search.email;
                            return Restangular.all('NotificationsTo').getList(options);
                        }
                    };
                }
            };

            var loadSending = function () {
                logService.debug($scope.gridSending);
                if (angular.isDefined($scope.gridSending)) {
                    $scope.gridSending.loadData(false);
                } else {
                    $scope.gridSending = {
                        pdfTitle: $filter('translate')('notifications.pdf_sent'),
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        gridMenuShowHideColumns: false,
                        paginationPageSizes: [10, 20, 30],
                        paginationPageSize: 10,
                        rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        columnDefs: [
                            { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                            { name: 'person_name', displayName: $filter('translate')('persons.name'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            { name: 'mails', displayName: $filter('translate')('companies.email'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            {
                                name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                    { title: $filter('translate')('notifications.edit_profile'), action: 'ng-click="grid.appScope.changeEmails(row.entity.id)"', cssIconClass: "fa fa-user" },
                                    { title: $filter('translate')('notifications.button_view'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit" },
                                ], { cssClass: "pull-right" })
                            },
                        ],
                        getData: function (options) {
                            options.notification_email_id = $stateParams.notificationId;
                            options.state = "pending";
                            return Restangular.all('NotificationsTo').getList(options);
                        }
                    };
                }
            };

            var loadError = function () {
                $scope.selectedRows = [];
                if (angular.isDefined($scope.gridError)) {
                    $scope.gridError.loadData(false);
                } else {
                    $scope.gridError = {
                        pdfTitle: $filter('translate')('notifications.pdf_sent'),
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        gridMenuShowHideColumns: false,
                        paginationPageSizes: [40, 100, 150],
                        paginationPageSize: 40,
                        rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                            this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                            this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
                        },
                        columnDefs: [
                            { name: 'id', visible: true, enableHiding: false, exporterSuppressExport: true, maxWidth: 80 },
                            {
                                name: 'real_send_date', displayName: $filter('translate')('notifications.date'), maxWidth: 125, minWidth: 80,
                                type: 'real_send_date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy HH:mm\'',
                                customFormatFn: function (value) {
                                    if (value != null) {
                                        var fecha = new Date(value);
                                        return $filter('date')(fecha, 'dd/MM/yyyy');
                                    }
                                    return "";
                                },
                                enableFiltering: false, enableColumnMenu: false
                            },
                            { name: 'person_name', displayName: $filter('translate')('persons.name'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            { name: 'mails', displayName: $filter('translate')('companies.email'), enableFiltering: false, enableHiding: false, enableColumnMenu: false },
                            { name: 'Re.', displayName: $filter('translate')('notifications.forwarded'), enableFiltering: true, enableHiding: false, cellTemplate: '<div ng-if="row.entity.count_resend_ok > 0 || row.entity.count_resend_error > 0" ><span ng-if="row.entity.count_resend_ok > 0" class=\"label label-small label-primary\" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="{{row.entity.resend_parent_ids_ok}}")>{{row.entity.count_resend_ok}}</span><span ng-if="row.entity.count_resend_error > 0" class=\"label label-small label-danger\" popover-placement="top" popover-append-to-body="true" popover-trigger="mouseenter" uib-popover="{{row.entity.resend_parent_ids_error}}">{{row.entity.count_resend_error}}</span>&nbsp;</span><i class=\"fa fa-share\"></i></span></div>' },
                            {
                                name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                    { title: $filter('translate')('notifications.email'), action: 'ng-click="grid.appScope.changeEmails(row.entity.id)"', cssIconClass: "fa fa-envelope-o" },
                                    { title: $filter('translate')('notifications.button_view'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit" },
                                ], { cssClass: "pull-right" })
                            },
                        ],
                        getData: function (options) {
                            options.notification_email_id = $stateParams.notificationId;
                            options.state = "error";
                            return Restangular.all('NotificationsTo').getList(options);
                        }
                    };
                }
            }

            $scope.search = function () {
                $scope.gridSent.loadData(false);
            }

            $scope.clearSearch = function () {
                $scope.search.email = null;
                $scope.search.fullname = null;

                $scope.gridSent.loadData(false);
            }

            if ($scope.event) {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('events.title'), url: "events.list" },
                    { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
                    { title: $filter('translate')('notifications.title'), url: "events.edit.notifications({ id: " + $scope.event.id + " })" },
                    { title: $filter('translate')('notifications.edit') }
                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('notifications.list'), url: "notifications.list" },
                    { title: $filter('translate')('notifications.edit') }
                ];
            }
            Restangular.one('NotificationsEmails', $stateParams.notificationId).get().then(function (results) {
                $scope.notification = results;

                logService.debug("he aquí los resultados")
                logService.debug(results)

                $scope.sent = results.status_sent;
                $scope.error = results.status_error;
                $scope.sending = results.status_sending;                

                $scope.notification.content = (window as any).CONFIG.api_url + "NotificationsAttachment/GetContentHTML?id=" + $scope.notification.id;
                
                _.each($scope.notification.FK_notifications_attachments_notifications_emails, function (attachment) {
                    attachment.downloadUrl = (window as any).CONFIG.api_url + 'NotificationsAttachment/getFile?uid=' + attachment.uid + '&filename=' + attachment.name
                });
            }, function (response) {
                $scope.errorMessage = response.message;
            });

            $scope.goToProfile = function (person_id) {
                $state.go("persons.edit", { person_type: 'authority', id: person_id });
            }

            let callbackFunctionRowSelected = function (row) {
                let addAll = row.length > 1;

                if (!addAll) { // Si solo hemos seleccionado uno 
                    var index = $scope.selectedRows.map(function (e) { return e }).indexOf(angular.isUndefined(row.entity) ? row[0].entity.id : row.entity.id);
                    if (index < 0) {
                        if (angular.isUndefined(row.isSelected)) {
                            if (row[0].isSelected) {
                                $scope.selectedRows.push(row[0].entity.id);
                            } else {
                                $scope.selectedRows = [];
                            }                            
                        } else {
                            if (row.isSelected) {
                                $scope.selectedRows.push(row.entity.id);
                            } else {
                                $scope.selectedRows.splice(index, 1);
                            }
                        }
                            
                    } else {
                        $scope.selectedRows.splice(index, 1);
                    }
                } else { //Si hemos seleccionado todos
                    if (row[0].isSelected) {
                        $scope.selectedRows = [];
                        for (let i = 0; i < $scope.gridError.gridApi.grid.options.totalItems; i++) { $scope.selectedRows.push(row[i].entity.id); };
                    } else {
                        $scope.selectedRows = [];
                    }
                }
            }

            $scope.goToEdit = function (rowEntity) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: NotificationsModalMailInfoView,
                    controller: 'NotificationsToInfoCtrl',
                    size: 'lg',
                    resolve: {
                        id: function () { return rowEntity.id; }
                    }
                });

                $modalInstance.result.then(function (bool) {
                    $scope.cancel();
                });
            }
        }

        $scope.changeEmails = function (notification_to_id) {
            //Funcion para cambiar los correos que estan mal, se cambia tanto en la notificacion como en el perfil de la autoridad
            let $modalInstance = $uibModal.open({
                animation: true,
                template: ChangeEmailsModalView,
                controller: 'ChangeEmailsCtrl',
                size: 'md',
                resolve: {
                    notification_to_id: function () { return notification_to_id; }
                }
            });

            $modalInstance.result.then(function (bool) {
                loadError();
            });

        }
        
        $scope.downloadFiles = function (attachments) {
            //Estos son los tipos devueltos: 0 = Gembox, 1 = Jasper, 2 = Files, 3 = Attachments
            angular.forEach($scope.notification.FK_notifications_attachments_notifications_emails, function (attachment) {
                if (attachment.type == 0 || attachment.type == 1) {
                    let arrayGuests = [];
                    angular.forEach($scope.notification.FK_notifications_to_notifications_emails, function (guest) {
                        arrayGuests.push(guest.event_guest_id);
                    })
                    let eventGuestsIds = arrayGuests.toString();
                    console.log(arrayGuests);
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                        params: { document_id: attachment.entity_type_id, event_id: $stateParams.id, event_guests_id: eventGuestsIds, order: 16, outputType: 'pdf', type: attachment.type }
                    }).then(function (result, status, headers, config) {
                        var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                        window.open(url, '_blank');
                    });

                } else {
                    window.open(attachment.downloadUrl, '_blank', '');
                }
            });
        }

        $scope.downloadFile = function () {
            _.each($scope.notification.FK_notifications_attachments_notifications_emails, function (attachment) {
                //Solo se descargarn los adjuntos que no sean Reports
                if (!attachment.entity_type) {
                    window.open(attachment.downloadUrl, '_blank', '');
                }
                
            });
        }

        $scope.addFile = function (flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                var uri = event.target.result;
                $scope.$apply(function () {
                    $scope.company.logo = uri;
                });
            };
            fileReader.readAsDataURL(flowFile.file);
        };


        $scope.setActive = function (data) {
            $scope.showData = data;
            if (data == "showSent") {
                loadSent();
            } else if (data == "showError") {
                loadError();
            } else {
                loadSending();
            }
            logService.debug($scope.showData);
        }


        $scope.cancel = function () {
            if ($scope.eventId != null) {
                $state.go("events.edit.notifications", { id: $scope.eventId });
            } else {
                $state.go("notifications.list");
            }
        }

        $scope.onResendAll = function () {
            if ($scope.selectedRows.length > 0) {
                Restangular.all("NotificationsTo").customPOST({}, "resend", { notificationsToIds: $scope.selectedRows }).then(function (results) {
                    if (results) {
                        $scope.cancel();
                    }
                });
            }
        }

    }])


    .controller('NotificationsToInfoCtrl', ['$scope', '$uibModalInstance', '$http', 'Restangular', '$filter', 'id', function ($scope, $uibModalInstance, $http, Restangular, $filter, id) {

        Restangular.one('NotificationsTo', id).get().then(function (result) {
            $scope.notificationsEmailInfo = result;
        });

        $scope.onResend = function () {
            var ids = new Array();
            ids.push(id);
            Restangular.all("NotificationsTo").customPOST({}, "resend", { notificationsToIds: ids }).then(function (results) {
                if (results) {
                    $uibModalInstance.close();
                }
            });
        }

        $scope.onResendAll = function () {
            var ids = new Array();
            ids.push(id);
            Restangular.all("NotificationsTo").customPOST({}, "resend", { notificationsToIds: ids }).then(function (results) {
                if (results) {
                    $uibModalInstance.close();
                }
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])
    .controller('ChangeEmailsCtrl', ['$scope', '$uibModalInstance', '$http', 'Restangular', '$filter', 'notification_to_id', function ($scope, $uibModalInstance, $http, Restangular, $filter, notification_to_id) {

        var email_old = null;
        Restangular.one('NotificationsTo', notification_to_id).get().then(function (result) {
            $scope.changeMail = result;
            email_old = result.mails;
        });

        $scope.onChangeMail = function () {
            Restangular.all("NotificationsTo").customPOST({}, "ChangeEmails", { notificationToId: $scope.changeMail.id, email: $scope.changeMail.mails, email_old: email_old }).then(function (results) {
                if (results) {
                    $uibModalInstance.close();
                }
            });
        }


        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

;